import { USERNAME_CHANGE_COOLDOWN_MS } from "./constants.js";
export function nextUsernameChangeAt(changedAt) {
    return changedAt === null ? null : changedAt + USERNAME_CHANGE_COOLDOWN_MS;
}
export function usernameChangeCutoff(now = Date.now()) {
    return new Date(now - USERNAME_CHANGE_COOLDOWN_MS);
}
//# sourceMappingURL=username.js.map